<template>

  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading" v-if="mode == 'BILLING'">Add Billing</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'BILLING_CHANGE'">Edit Billing</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'COST'">Add Cost</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'COST_CHANGE'">Edit Cost</md-dialog-title>

      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">
        
        <div v-if="mode == 'BILLING' || mode == 'BILLING_CHANGE'" class = "layout">
          <auto-complete-master-data-select  :class="getValidationClass('dataForm.rateType')"
                                              group="GST_RATE_BILLING"
                                              label="RATE TYPE"
                                              :init-value="dataForm.rateType"
                                              :on-item-changed="handleRateTypeChanged"
                                              :disabled="mode == 'BILLING_CHANGE'"
                                              >
          </auto-complete-master-data-select>

          <md-field>
            <label for="rdesc">Description</label>
            <md-input name="rdesc"
                      id="rdesc"
                      autocomplete="new-password"
                      v-model="dataForm.rdesc"
                      disabled
            />
          </md-field>

          <md-field>
            <label for="unit">Measure Unit</label>
            <md-input name="unit"
                      id="unit"
                      autocomplete="new-password"
                      v-model="dataForm.unit"
                      disabled
            />
          </md-field>
        </div>


        <div v-if="mode == 'COST' || mode == 'COST_CHANGE'" class = "layout">
          <auto-complete-master-data-select  :class="getValidationClass('dataForm.rateType')"
                                              group="GST_RATE_COST"
                                              label="RATE TYPE"
                                              :init-value="dataForm.rateType"
                                              :on-item-changed="handleRateTypeChanged"
                                              :disabled="mode == 'COST_CHANGE'"
                                              >
          </auto-complete-master-data-select>

          <md-field>
            <label for="rdesc">Description</label>
            <md-input name="rdesc"
                      id="rdesc"
                      autocomplete="new-password"
                      v-model="dataForm.rdesc"
                      disabled
            />
          </md-field>

          <md-field>
            <label for="unit">Measure Unit</label>
            <md-input name="unit"
                      id="unit"
                      autocomplete="new-password"
                      v-model="dataForm.unit"
                      disabled
            />
          </md-field>
        </div>

        <div class = "layout">
          <md-field>
            <label for="amt">Unit Price</label>
            <md-input name="amt"
                      id="amt"
                      autocomplete="new-password"
                      v-model="dataForm.amt"
            />
          </md-field>


          <div v-if="this.dataForm.unit == 'FIXED'">
            <md-field>
              <label for="qty">Quantity</label>
              <md-input name="qty"
                        id="qty"
                        autocomplete="new-password"
                        v-model="dataForm.qty"
                        disabled
                        />
            </md-field>
          </div>

          <div v-if="this.dataForm.unit != 'FIXED'">
            <md-field>
              <label for="qty">Quantity</label>
              <md-input name="qty"
                        id="qty"
                        autocomplete="new-password"
                        v-model="dataForm.qty"
              />
            </md-field>
          </div>

          <datepicker v-model="dataForm.settleDate" >
            <label>Settle Date</label>
          </datepicker>          
        </div>

        <div class = "layout">
               
          <md-field>
            <label for="pf">Partner Type</label>
              <md-select v-model="dataForm.pf">
              <md-option value="CU">Customer</md-option>
              <md-option value="DR">Driver</md-option>
              <md-option value="OC">Ocean Carrier</md-option>
              <md-option value="CV">Chassis Vendor</md-option>
              <md-option value="SV">STC Vendor</md-option>
            </md-select>
          </md-field>

          <div v-if="dataForm.pf == null">
            <md-field>
              <label for="partner">Partner</label>
              <md-input name="partner"  id="partner" autocomplete="new-password" v-model="dataForm.partner" disabled/>
            </md-field>
          </div>

          <div v-if="dataForm.pf == 'CU'">
            <auto-complete-master-data-select
              group="STC_CUSTOMER" label="Customer" :init-value="dataForm.partner" :on-item-changed="handleCustIDChanged" >
            </auto-complete-master-data-select>
          </div>

          <!-- <div v-if="dataForm.pf == 'DR'">
            <auto-complete-master-data-select
              :prepared-options="drivers"
              label="Driver"
              :init-value="dataForm.partner"
              :on-item-changed="handleDriverRequestChanged">
            </auto-complete-master-data-select>
          </div> -->

              
                  
          <div v-if="dataForm.pf == 'DR'">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="dataForm.partner"
                      :on-item-changed="changeAsgDriverId(dataForm)">
                 </auto-complete-select>     
          </div>     
                   

          <div v-if="dataForm.pf == 'OC'">
            <auto-complete-master-data-select
              group="STC_CARRIER" label="Vendor" :init-value="dataForm.partner" :on-item-changed="handleScacChanged" >
            </auto-complete-master-data-select>
          </div>


          <div v-if="dataForm.pf == 'CV'">
            <auto-complete-master-data-select 
              group="STC_CHASSIS_VENDOR" label="Vendor" :init-value="dataForm.partner" :on-item-changed="handleChassisChanged" >
            </auto-complete-master-data-select>
          </div>

          <div v-if="dataForm.pf == 'SV'">
            <auto-complete-master-data-select
              group="STC_VENDOR" label="Vendor" :init-value="dataForm.partner" :on-item-changed="handleSTCvendorChanged" >
            </auto-complete-master-data-select>
          </div>

          <md-field>
            <label for="remark">Remark</label>
            <md-input name="remark"
                      id="remark"
                      autocomplete="new-password"
                      v-model="dataForm.remark"
            />
          </md-field>

        </div>

        <div class = "alwaysShow">
          <div >
              <callingApiCenter class = "custButtonRight" type="bar" :paths="['/api/w/apar/update']"></callingApiCenter>
              <md-dialog-actions >
              <md-button class="md-raised custButton " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Cancel</md-button>
              <md-button type="submit" class="md-raised custButton md-primary"><span class="icons-center material-icons">save</span>Save</md-button>
            </md-dialog-actions>
          </div>
        </div>
        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
    
  }
  

  .alwaysShow {
  position: fixed;
  
  right: 60px;
  top : 30px;
}


    .redButton{

        background-color: #c50000;
        z-index: 4;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    }


.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}



  .custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}



    .heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 32px;
      font-family: Roboto Slab;
      margin-left: 44px;


}

  .layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
      display:flex;
      font-family: Roboto Slab;
      margin: auto;
  }


  .md-table-row
{
  background: white;
}


.md-table.md-theme-default .md-table-row.md-selected-single
{
background: #726a95;
}



</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import callingApiCenter from "./CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import moment from 'moment';

  const getInitialdataForm = () => ({
    mode: null,
    salesOffice: null,
    billingNumRateType: null,
    rateType: null,
    unit: null,
    amt: null,
    qty: null,
    tol: null,
    pf: null,
    partner: null,
    driverId: null,
    settleDate: moment(moment().endOf('week').subtract(7,'days').toDate()).format('M/D/YYYY'),
    remark: null
    
  });

const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null
})

  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter},
    mixins: [validationMixin],
    props: {
      mode: String,
      action: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      searchDriverReq: getInitDriverSearch(),
      items: [],
      selected:null,
      drivers: [],
     driverIds: [],
     driverNames: [],
     driverContent: [],
    }),
    computed: {
      ...mapGetters([
        'getMasterDataAsSelectOptionByGroup',
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
        'getSTCDriverGroup',
        'getGSTDriverMaster',
      ]),
      
    },

    validations: {
      dataForm: {
          rateType: {},
          rdesc: {},
      },
    },

     async mounted() {
      this.searchDriverReq.driverOffice = "STC";
      this.searchDriverReq.defaultSalesOffice = "LGB";
      this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq);
      this.updateDrivers(this.getGSTDriverMaster);

      // this.$store.dispatch('getUsersByCategory', { category: 'L' })
      //   .then((res) => {
      //     this.drivers = res;
      //   });
    },


    methods: {

      async openDialog(existingUser) {
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();

        this.dataForm.salesOffice = existingUser.salesOffice
        this.dataForm.billingNumRateType = existingUser.billingNumRateType
        console.log("mode: " + this.mode);
        if (existingUser && (this.mode == 'BILLING_CHANGE' || this.mode == 'COST_CHANGE')) {
            this.dataForm.rateType = existingUser.rateType;
            this.dataForm.rdesc = existingUser.rdesc;
            this.dataForm.unit = existingUser.unit;
            this.dataForm.amt = existingUser.amt;  
            this.dataForm.qty = existingUser.qty;  
            this.dataForm.tol = existingUser.tol;  
            this.dataForm.partner = existingUser.partner;  
            this.dataForm.pf = existingUser.pf;
            console.log("existingUser.settleDate: " + existingUser.settleDate);  
            if (existingUser.settleDate == null)
            {
              this.dataForm.settleDate = moment(moment().endOf('week').subtract(7,'days').toDate()).format('M/D/YYYY');
            }
            else{
              this.dataForm.settleDate = this.convertDateForDatePicker(existingUser.settleDate);
              //this.dataForm.settleDate = moment(moment(existingUser.settleDate).endOf('week').subtract(7,'days').toDate()).format('M/D/YYYY'); 
            }
            
             
            this.dataForm.refDoc = existingUser.refDoc;  
            this.dataForm.seqNo = existingUser.seqNo;  
        }
        this.showDialog = true;
      },

        async updateDrivers(itemsSource) {
          var items = itemsSource;
          if (items && items.length > 0) {  
             items.forEach((it) => {
                var driverInfo = it.shortId + "(" + it.userName + ")";
                this.drivers.push(driverInfo);
                this.driverIds.push(it.driverId);
                this.driverNames.push(it.userName);
                this.driverContent.push(driverInfo);
             })
          } else {
             //await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
             await newAPIPost('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
                 .then ( (driverinfo) => {
                    if (driverinfo) {
                        driverinfo.forEach( (it) => {
                            console.log("driver: " + it.shortId);
                            var driverInfo = it.shortId + "(" + it.userName + ")";
                            this.drivers.push(driverInfo);
                            this.driverIds.push(it.driverId);
                            this.driverNames.push(it.userName);
                            this.driverContent.push(driverInfo);
                        })
                    }
             });
          }
          console.log("drivers: [[" + this.drivers + "]]");
    
        },

    getdriverUserNameFromDriver(driver) {
         return this.getContentFromBrace(driver);
    },

    getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  //console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  //console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
    },

    getdriverFromUsername(username) {
         var indx = 0;
         var findIndx = -1;
         if (username && username != "") {
            this.driverNames.forEach( (it) => {
               if (it == username) {
                  findIndx = indx;
               }
               indx += 1;
            })
            if (findIndx > -1) {
               return this.drivers[findIndx];
            } else {
               return username;
            }
         } else {
            return username;
         }
    },

      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

    // handleDriverRequestChanged(id) {
    //     this.dataForm.partner = id;
    //   },

        changeAsgDriverId(dataForm) {
           return (driver) => {
               dataForm.driverId = this.getdriverUserNameFromDriver(driver);
               dataForm.partner = this.getdriverUserNameFromDriver(driver);
           }
        },
  
    handleSTCvendorChanged(id, name){
          console.log(`handleSTCvendorChanged`, id, name);
        this.dataForm.partner = id;
      },  


    handleChassisChanged(id, name){
          console.log(`handleChassisChanged`, id, name);
        this.dataForm.partner = id;
      },

    handleScacChanged(id, name){
          console.log(`handleScacChanged`, id, name);
        this.dataForm.partner = id;
      },

      handleCustIDChanged(id, name){
          console.log(`handleCustIDChanged`, id, name);
        this.dataForm.partner = id;
      },

      handleRateTypeChanged(id, name, unit) {
        console.log(`handleStageTypeChanged`, id, name, unit);
    
        this.dataForm.rateType = id;
        this.dataForm.rdesc = name;
        this.dataForm.unit = unit;
        if (this.dataForm.unit == "FIXED") {
          this.dataForm.qty = 1;
        }
        else {
          this.dataForm.qty = 0;
        };
        this.dataForm.amt = 0;

      },

      convertDateForDatePicker(date, type) {
        var day = "";
        var month = "";
        var year = "";
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          if (date.indexOf("T") < 1 && date.indexOf("-") > 1) date = date + "T00:00:00" 
          var processDate = new Date(date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
     },

     cancalAction(){
        this.showDialog = false;
        this.$store.commit('clearApiError');
     },

      async doSaveUser() {
       
        if (this.dataForm.rateType == null)
        {
          alert("Rate Type is required!")
          return 
        }

        if (this.dataForm.amt < 1 )
        {
          alert("Unit Price is required!")
          return 
        }

        if (this.dataForm.qty < 0.1 )
        {
          alert("Quantity is required!")
          return 
        }

        if (this.dataForm.pf == null || this.dataForm.pf == "")
        {
          alert("Partner Type is required!")
          return 
        }

        if (this.dataForm.partner == null || this.dataForm.partner == "")
        {
          alert("Partner Name is required!")
          return 
        }


        this.$v.dataForm.$touch();
        console.log(JSON.stringify(this.dataForm));
        const req = this.dataForm;
        req.settleDate =  dateFormat.getLocalDateOnly(req.settleDate)
        //this.dataForm.tol = parseInt(this.dataForm.amt) * parseInt(this.dataForm.qty);
        this.dataForm.tol = parseFloat(this.dataForm.amt).toFixed(2) * parseFloat(this.dataForm.qty).toFixed(2);
        this.dataForm.tol = this.dataForm.tol.toFixed(2);

        if (this.mode == 'BILLING')
        {
          req.mode = "BC"
          console.log(req);
        //await  api.post("/api/w/apar/update", req)
        await  newAPIPost("/api/w/apar/update", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.action('Item created!');
          });
        }

        if (this.mode == 'COST')
        {
          req.mode = "CC"
          console.log(req);
        //await  api.post("/api/w/apar/update", req)
        await  newAPIPost("/api/w/apar/update", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.action('Item created!');
          });
        }
  
        if (this.mode == 'BILLING_CHANGE')
        {
          req.mode = "BU"
         //await  api.post("/api/w/apar/update", req)
         await  newAPIPost("/api/w/apar/update", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.action('Item Update!');
          });
        }

        if (this.mode == 'COST_CHANGE')
        {
          req.mode = "CU"
         //await  api.post("/api/w/apar/update", req)
         await  newAPIPost("/api/w/apar/update", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.action('Item Update!');
          });
        }

         this.$store.commit('clearApiError');
      },
    },
  };
</script>
